// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newRentalName {\n  width: 25%;\n  height: 50px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  border: none;\n  border-radius: 0px;\n  color: #495057;\n  background-color: #eeeeee;\n}\n\n.baseButtonModal {\n  background-color: #0E5371 !important;\n  color: white;\n  width: 100px;\n  border: none;\n  box-shadow: 1px 1px 3px 0px #707070;\n  height: 50px;\n}\n\n.listName:hover {\n  color: #0E5371;\n}\n", ""]);
// Exports
module.exports = exports;
